import ArrowDown from './ArrowDown';
import ArrowUp from './ArrowUp';
import ChevronDown from './ChevronDown';
import ChevronLeft from './ChevronLeft';
import ChevronRight from './ChevronRight';
import Close from './Close';
import ColorPalette from './ColorPalette';
import Droplet from './Droplet';
import Edit from './Edit';
import ExpandArrowsAlt from './ExpandArrowsAlt';
import Filter from './Filter';
import Image from './Image';
import Layout from './Layout';
import Loading from './Loading';
import MetroShrink from './MetroShrink';
import Redo from './Redo';
import Resize from './Resize';
import Ruler from './Ruler';
import Search from './Search';
import SortAlphaDown from './SortAlphaDown';
import SortAlphaUp from './SortAlphaUp';
import Tag from './Tag';
import ToggleOn from './ToggleOn';
import ToggleOff from './ToggleOff';
import Undo from './Undo';
import Upload from './Upload';
import Public from './Public';
import Add from './Add';
import Print from './Print';

const collection = {
  ArrowDown,
  ArrowUp,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Close,
  ColorPalette,
  Droplet,
  Edit,
  ExpandArrowsAlt,
  Filter,
  Image,
  Layout,
  Loading,
  MetroShrink,
  Redo,
  Resize,
  Ruler,
  Search,
  SortAlphaDown,
  SortAlphaUp,
  Tag,
  ToggleOn,
  ToggleOff,
  Undo,
  Upload,
  Public,
  Add,
  Print,
};

export default collection;
